import SettingIcon from '@material-ui/icons/Settings';

import ParametersEdit from './edit';

export default {
  edit: ParametersEdit,
  icon: SettingIcon,
};
